var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.887153 0.888916H14.8872C15.0934 0.888916 15.2913 0.97086 15.4371 1.11672C15.583 1.26258 15.6649 1.46041 15.6649 1.66669V14.1111C15.6649 14.3174 15.583 14.5152 15.4371 14.6611C15.2913 14.807 15.0934 14.8889 14.8872 14.8889H0.887153C0.680873 14.8889 0.483042 14.807 0.337181 14.6611C0.191319 14.5152 0.109375 14.3174 0.109375 14.1111V1.66669C0.109375 1.46041 0.191319 1.26258 0.337181 1.11672C0.483042 0.97086 0.680873 0.888916 0.887153 0.888916ZM14.1094 4.18514L7.94315 9.70736L1.66493 4.16803V13.3334H14.1094V4.18514ZM2.06238 2.44447L7.9346 7.62603L13.722 2.44447H2.06238Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactMail);
export default __webpack_public_path__ + "static/media/ContactMail.33a0dff97913764a86f4e6701d9758ff.svg";
export { ForwardRef as ReactComponent };